angular.module('admin.users', [
  'admin.users.index',
  'admin.users.add',
  'admin.users.detail'
]);



// WEBPACK FOOTER //
// ./client/src/app/admin/users/index.js